import React, { useMemo, useState } from 'react';
import { useApp } from '../context/AppContext';
import { useT } from '../i18n/translations';
import { PRODUCTS, CATEGORIES } from '../data/catalog';
import GameCard from './GameCard';
import Icon from './Icon';
import './ProductGrid.css';

const SORTS = [
  { id: 'priceAsc', label: '面額 由小到大' },
  { id: 'priceDesc', label: '面額 由大到小' },
];

export default function ProductGrid({
  initialCategory = 'all',
  showFilters = true,
}) {
  const { lang, navigate } = useApp();
  const t = useT(lang);
  const [cat, setCat] = useState(initialCategory);
  const [sort, setSort] = useState('priceAsc');

  const items = useMemo(() => {
    let list = PRODUCTS.slice();
    if (cat !== 'all') list = list.filter((p) => p.category === cat);
    if (sort === 'priceDesc') {
      list.sort((a, b) => b.denominations[0].price - a.denominations[0].price);
    } else {
      list.sort((a, b) => a.denominations[0].price - b.denominations[0].price);
    }
    return list;
  }, [cat, sort]);

  const section = {
    eyebrow: '全部商品',
    title: 'MyCard 點數卡 · 7 種面額',
    lead: '從 50 點入門到 5000 點大額儲值，選擇最適合您的面額',
  };

  return (
    <section className="section nx-pg">
      <div className="container">
        <div className="section-title">
          <div>
            <div className="eyebrow">{section.eyebrow}</div>
            <h2>{section.title}</h2>
            <p className="lead">{section.lead}</p>
          </div>
          <button
            className="btn btn-ghost btn-sm"
            onClick={() => navigate('category', { id: cat })}
          >
            {t.cta.viewAll} <Icon name="arrowRight" size={14} />
          </button>
        </div>

        {showFilters && (
          <div className="nx-pg__filters">
            <div className="nx-pg__chips">
              {CATEGORIES.map((c) => (
                <button
                  key={c.id}
                  className={`nx-pg__chip ${cat === c.id ? 'is-active' : ''}`}
                  onClick={() => setCat(c.id)}
                >
                  {c.name[lang] || c.name['zh-TW']}
                </button>
              ))}
            </div>
            <div className="nx-pg__sort">
              <Icon name="sparkle" size={14} />
              <select value={sort} onChange={(e) => setSort(e.target.value)}>
                {SORTS.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        <div className="nx-pg__grid">
          {items.length === 0 ? (
            <div className="nx-pg__empty">
              <Icon name="search" size={32} />
              <p>此分類目前沒有商品，請嘗試其他分類。</p>
            </div>
          ) : (
            items.map((p, i) => (
              <div key={p.id} style={{ animationDelay: `${i * 40}ms` }}>
                <GameCard product={p} />
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
